const lang = {
  actionButton: {
      confirm: 'Xác nhận',
      cancel: 'Hủy',
  },
};
export default lang;
